export const appConfig = {
    domain: 'https://test2-back.metamsk.ru',
    // domain: 'https://back.metamsk.ru',
    // domain: 'http://localhost:3000',
    // domain: 'https://metamsk.ru:8086',
    // socket: 'wss://45.145.65.197:3001/'
}